import { computed, unref, type MaybeRef } from 'vue';
import { themeOption } from '@/helpers/theme.helper';
import type { Locales, ThemeHost } from '@/services/types/api.types';
import { useConfigurationStore } from '@/stores';

// The options of a theme selector: the manifest's themes that cover the host, labelled in the given languages.
export const useThemeOptions = (host: ThemeHost, languageEnabled: MaybeRef<Locales[] | undefined>) => {
  const configurationStore = useConfigurationStore();
  return computed(() => configurationStore.getThemes(host).map((theme) => themeOption(theme, unref(languageEnabled))));
};
